import {observable} from 'mobx';

export class ChangeSettingsModalState {
    @observable isVisible: boolean = false;
    @observable passwordOnly: boolean = false;
    @observable showOldPassword: boolean = false;
    @observable showNewPassword: boolean = false;
    @observable showConfirmPassword: boolean = false;
    @observable saving: boolean = false;
    @observable wrongPassword: boolean = false;
    @observable usedPassword: boolean = false;
    @observable formSubmitted: boolean = false;
    accountData: any;
}
